export default "__VITE_ASSET__2aa6ad00__"